// composables/useToast.ts
import { ref } from 'vue'

export type ToastType = 'success' | 'error' | 'info'
export type ToastMsg = { id: string; type: ToastType; text: string }

const toasts = ref<ToastMsg[]>([])

function push(type: ToastType, text: string, ttl = 2200) {
    const id = crypto.randomUUID()
    toasts.value.push({ id, type, text })
    setTimeout(() => {
        toasts.value = toasts.value.filter((t) => t.id !== id)
    }, ttl)
}

export function useToast() {
    return {
        toasts,
        success: (t: string) => push('success', t),
        error: (t: string) => push('error', t, 3200),
        info: (t: string) => push('info', t),
    }
}